var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmaildropdownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5628 9.50317C12.0921 9.78288 11.5516 9.93138 11 9.93138C10.4484 9.93138 9.90786 9.78288 9.43643 9.5016L0 3.90967V14.0642C0 15.3607 1.05286 16.4214 2.35714 16.4214H19.6429C20.9471 16.4214 22 15.3607 22 14.0642V3.90967L12.5628 9.50317Z",
    fill: "#A9A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1585 8.28614C10.4131 8.43779 10.703 8.51714 11 8.51714C11.297 8.51714 11.5877 8.437 11.8407 8.28693L21.9914 2.27071C21.945 1.01514 20.9173 0 19.6429 0H2.35717C1.08274 0 0.0550241 1.01514 0.00866699 2.27071L10.1585 8.28614Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaildropdownicon);
export default __webpack_public_path__ + "static/media/emaildropdownicon.74ff93f8a284df1c48d9f0e7fb300ba3.svg";
export { ForwardRef as ReactComponent };